import {
    Component,
    OnInit,
    Output,
    EventEmitter,
    ViewChild
} from "@angular/core";
import {ModalAmountService} from "src/app/services/ux/modal-amount.service";

@Component({
    selector: "app-modal-tatime-amount",
    templateUrl: "./modal-tatime-amount.component.html",
    styleUrls: ["./modal-tatime-amount.component.css"]
})
export class ModalTatimeAmountComponent implements OnInit {
    open = false;

    @Output() amountSubmitted: EventEmitter<number> = new EventEmitter<number>();

    @ViewChild("amount") shumaInput;

    constructor(private modalService: ModalAmountService) {
    }

    ngOnInit() {
        // * Subscribe to modelState$ to open/close the modal
        this.modalService.modalState$.subscribe({
            next: (state: boolean) => {
                if (!state) {
                    this.shumaInput.nativeElement.value = "";
                }
                this.open = state;
            }
        });
    }

    // TODO: Should do checks about amount
    submitAmount(amount: number) {
        if (!amount) {
            this.amountSubmitted.emit(null);
            return;
        }

        this.amountSubmitted.emit(amount);
    }

    close() {
        this.modalService.close();
    }
}
